<template>
  <section class="section">
    <div class="container no-print">
      <div class="columns">
        <div class="column">
          <h2 class="title">
            ລາຍງານການນຳໃຊ້ເງິນ
          </h2>
        </div>
      </div>
      <div class="columns" style=" margin-top: -40px;">
        <div class="column">
            ຍອດເງິນ: <span style="color:red; font-size: 24px; margin-left: 5px; margin-right: 5px;"> {{ accountBalance | formatNumberLocal }} </span> ກີບ
          
        </div>
      </div>
      <b-tabs v-model="activeTab" v-if="roleid == 29">
        
        <b-tab-item label="ລາຍການເຄື່ອນໄຫວ">
          <div class="columns">
            <div class="column">
              <b-field>
                
                <b-field label="ຈາກວັນທີ">
                  <b-datepicker
                    :date-formatter="dateFormatter"
                    v-model="startdate"
                  >
                  </b-datepicker>
                </b-field>
                <b-field style="padding-left: 20px; padding-right: 20px;">  </b-field>
                <b-field label="ເຖິງວັນທີ">
                  <b-datepicker
                    :date-formatter="dateFormatter"
                    v-model="enddate"
                  >
                  </b-datepicker>
                </b-field>

                
              </b-field>
            </div>
          </div>
          <div class="columns" style="margin-top: -70px;">
            <div class="column">
              <b-field>
                
                
               
                <b-field  style="margin-top: 30px;">
                  <b-button
                    class="btn-group-margin"
                    type="is-primary"
                    @click="getBalanceStatement()"
                    >ດຶງລາຍການ
                  </b-button>
                </b-field>

                
              </b-field>
            </div>
          </div>
          <table class="table is-fullwidth is-narrow is-small">
            <thead>
              <tr>
              
                <th class="has-text-centered " width="2%">
                  #
                </th>
                <th class="has-text-centered " width="5%">
                  ວັນທີ
                </th>
                <th class="has-text-left " width="20%">
                  ລາຍການ
                </th>
                
                <th class="has-text-right " width="10%">
                  ເງິນເຂົ້າ<br>
                  ເງິນອອກ
                </th>
                <th class="has-text-right " width="10%">
                  ຍັງເຫຼືອ
                </th>
              
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data,index) in accountStatement"
                :key="data.ID"
              >
                <td class="has-text-centered">
                  {{ index + 1 }}
                </td>
                <td class="has-text-centered">
                  {{data.TXDATE }}
                </td>
                <td class="has-text-left">
                  {{data.TITLE }}<br>
                  {{data.REMARK }}
                </td>
                <td class="has-text-right">
                  <span style="color: green; font-weight: bold;">{{data.CREDIT | formatNumberLocal }}</span><br>
                  <span style="color: red; font-weight: bold;">{{data.DEBIT | formatNumberLocal}}</span><br>
                  <b-button v-if="data.TYPEID !=1"
                    class="btn-group-margin"
                    type="is-info"
                    size="is-small"
                    @click="getStatementDetail(data.ID)"
                    >ລາຍລະອຽດ
                  </b-button>
                </td>
                <td class="has-text-right">
                  {{data.REMAIN | formatNumberLocal}}
                </td>
              
              </tr>
            </tbody>
          </table>
        </b-tab-item>
        <b-tab-item label="ລາຍລະອຽດ">
          <table class="table is-fullwidth is-narrow is-small">
            <thead>
              <tr>
              
                <th class="has-text-centered " width="5%">
                  #
                </th>
                <th class="has-text-centered " width="20%">
                  ສິນຄ້າ
                </th>
                <th class="has-text-right " width="20%">
                  ຈຳນວນ
                </th>
                
                <th class="has-text-right " width="30%">
                  ຈຳນວນເງິນ
                </th>
               
              
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data, index) in statementdetaillist"
                :key="data.PRODUCTID"
              >
                <td class="has-text-centered">
                  {{ index + 1 }}
                </td>
                <td class="has-text-centered">
                  {{data.PRODUCTNAME }}<br>
                  <img
                    class="image-area"
                    style="width: 100%; max-width: 100px; "
                    :src="getImgUrl('products/' + data.PHOTONAME)"
                    
                  />  
                </td>
                <td class="has-text-right">
                  {{data.QUANTITY | formatNumberLocal }}
                </td>
                <td class="has-text-right">
                  {{data.TOTALPRICE | formatNumberLocal}}
                </td>
   
              </tr>
            </tbody>
            <tfoot>
              <tr>
                <th colspan="3" class="has-text-right">
                  ລວມ 
                </th>
                <th  class="has-text-right">
                  {{ _.sumBy(statementdetaillist, i => i["TOTALPRICE"]) | formatNumberLocal }}
                </th>             
              </tr>
            </tfoot>
          </table>
        
           
        </b-tab-item>
        
        
      </b-tabs>
    </div>


  
    
  </section>
</template>

<script>
import RestAPI from "../../RestAPI";
import moment from "moment";

export default {

  props: ["MONTH"],
  data() {
    return {
      roleid: null,

      activeTab: 0,
      activeSubTab: 0,
      startdate: null,
      enddate: null,


      activeSub2TabList: 0,
      purchaselist: [],

      photopath:
        process.env.NODE_ENV === "production"
          ? "https://agrilao.com/agrilao-manager/api/uploads/"
          // : "http://localhost/agrilao-manager/api/uploads/",
          : "https://agrilao.com/manager-main/api/uploads/",

      selectedPurchaseDate: null,
      productList: [],
      productRemainConfirm: [],
      productSubList: [],
      productPromotionList: [],
      productAllList: [],

      isPopupVisible: false,
      popupImgSrc: '',
      accountStatement: [],

      accountBalance: 0,
      statementdetaillist: [],
      
    };
  },
  methods: {
    getStatementDetail(statementid){
      this.activeTab = 1;
      RestAPI.getStatementDetail(statementid)
        .then((res) => {
          this.statementdetaillist = res.data;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    getPurchaserAccountBalance() {
    RestAPI.getPurchaserAccountBalance( this.username)
      .then((res) => {
        this.accountBalance = res.data;
        // console.log("accountBalance: " + JSON.stringify(res.data))
        // console.log("res: " + JSON.stringify(res.data))
      })
      .catch((error) => {
        console.log(error);
        this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
      });
    },

    getBalanceStatement() {

      console.log("startdate-: " + this.startdate)
      RestAPI.getBalanceStatement(this.username, this.dateFormatterYYYYMMDD(this.startdate), this.dateFormatterYYYYMMDD(this.enddate))
        .then((res) => {
          this.accountStatement = res.data;
          // console.log("accountStatement: " +JSON.stringify(this.accountStatement))
        })
        .catch((error) => {
          console.log(error);
          this.$swal("ມີຂໍ້ຜິດພາດ", "-", "error");
        });
    },
    
    getImgUrl(photoname) {
      var photopreview = photoname
        ? this.photopath + photoname
        : this.photopath + "unknown.png";
      return photopreview;
    },

    dateFormatter(date) {
      return new moment(date).format("DD/MM/YYYY");
    },
    dateFormatterYYYYMMDD(date) {
      return new moment(date).format("YYYY-MM-DD");
    },
    year(date) {
      return new moment(date).format("YYYY");
    },

    
  },
  mounted() {
    this.roleid = this.user.ROLEID;
    this.username = this.user.USERNAME;
    this.startdate = new Date(new Date().getFullYear(), new Date().getMonth(), 1);  
    this.enddate = new Date();
    this.getBalanceStatement();
    this.getPurchaserAccountBalance();
  },

  computed: {
    formdatestr() {
      return new moment(this.formdate).format("YYYY-MM-DD");
    },


  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.popup {
  display: block;
  position: fixed;
  z-index: 1;
  padding-top: 60px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.9);
}

/* Style for the close button */
.close {
  position: absolute;
  top: 15px;
  right: 35px;
  color: #f1f1f1;
  font-size: 40px;
  font-weight: bold;
  transition: 0.3s;
}

.close:hover,
.close:focus {
  color: #bbb;
  text-decoration: none;
  cursor: pointer;
}

/* Style for the popup content (image) */
.popup-content {
  margin: auto;
  display: block;
  width: 80%;
  max-width: 700px;
}

/* Add animation (optional) */
.popup-content {
  -webkit-animation-name: zoom;
  -webkit-animation-duration: 0.6s;
  animation-name: zoom;
  animation-duration: 0.6s;
}

@-webkit-keyframes zoom {
  from { -webkit-transform: scale(0); }
  to { -webkit-transform: scale(1); }
}

@keyframes zoom {
  from { transform: scale(0); }
  to { transform: scale(1); }
}

.text-right-input input {
  text-align: right;
}

.custom-align {
    text-align: right;
}
.asterisk {
  color: red;
}

.set-border {
  border: 1px solid #ddd;
}

/* .summary-footer {
  page-break-before: always;
} */

.modal {
  display: none;
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
}

/* Style for the modal content */
.modal-content {
  background-color: #fefefe;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #888;
  width: 80%;
}

/* Style for the close button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

@media print {
  @page {
    margin-top: 0; /* Set the initial margin for the first page */
  }
}
</style>
